import { z } from 'zod';

/**
 * Schemas Zod do onboarding.
 *
 * D14 do briefing: schemas ficam em `apps/web/src/schemas/` por enquanto.
 * Sprint 05+ avalia mover para `packages/shared` quando houver duplicação.
 *
 * Backend é fonte da verdade (D15) — frontend valida só formato. Ex: CNPJ
 * → só checa 14 dígitos; algoritmo de DV roda no backend.
 */

const cnpjRegex = /^\d{14}$|^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/;

export const onboardingSchema = z
  .object({
    codigoInstalacao: z
      .string()
      .trim()
      .length(32, 'O código de instalação deve ter 32 caracteres.')
      .regex(/^[0-9a-fA-F]+$/, 'O código deve conter apenas caracteres hexadecimais.'),
    razaoSocial: z.string().trim().min(1, 'Razão social é obrigatória.').max(255),
    nomeFantasia: z.string().trim().min(1, 'Nome fantasia é obrigatório.').max(255),
    cnpj: z
      .string()
      .trim()
      .optional()
      .or(z.literal(''))
      .refine((v) => !v || cnpjRegex.test(v), 'CNPJ deve ter 14 dígitos (com ou sem máscara).'),
    telefone: z.string().trim().optional().or(z.literal('')),
    nome: z.string().trim().min(1, 'Nome do gestor é obrigatório.').max(255),
    email: z.string().trim().email('Email inválido.').max(255),
    senha: z
      .string()
      .min(10, 'A senha deve ter ao menos 10 caracteres.')
      .regex(/[A-Z]/, 'A senha deve conter ao menos 1 letra maiúscula.')
      .regex(/[0-9]/, 'A senha deve conter ao menos 1 número.'),
    confirmacaoSenha: z.string(),
  })
  .refine((d) => d.senha === d.confirmacaoSenha, {
    message: 'As senhas não conferem.',
    path: ['confirmacaoSenha'],
  });

export type OnboardingForm = z.infer<typeof onboardingSchema>;
